export default __webpack_public_path__ + "static/media/BDI.be907f7e.svg";